import { useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';
import { useRequestState } from './useRequestState';

interface QueryCountResponse {
    taskId?: string;
    count?: number;
    status?: string;
    message?: string;
}

const toCountErrorMessage = (message?: string): string => message?.includes('bad SQL grammar')
    ? 'La requête génère un SQL invalide. Vérifiez les critères puis relancez le comptage.'
    : message || 'Erreur lors du comptage';

export const useQueryCount = () => {
    const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
    const { loading, error, run, reset } = useRequestState();

    const launchQueryCount = useCallback(async (queryId: string | number): Promise<QueryCountResponse | null> => {
        if (!isReady || !queryId) return null;

        return run(async () => {
            const response: QueryCountResponse = await authFetch('/queryCount', {
                method: 'POST',
                body: JSON.stringify({ queryId: String(queryId) }),
            });
            if (response?.status?.toUpperCase() === 'ERROR') throw new Error(toCountErrorMessage(response.message));
            return response;
        }, 'Erreur lors du comptage');
    }, [authFetch, isReady, run]);

    return { launchQueryCount, loading, error, reset };
};
